<lib-page-header title="Users">
    <mat-icon icon>people</mat-icon>
    <ng-container stats *ngIf="dataSetSize > 0">
        <div class="page-header-stat">
            <mat-icon>person</mat-icon>
            <span class="stat-value">{{ dataSetSize }}</span>
            <span class="stat-label">Total</span>
        </div>
    </ng-container>
    <ng-container actions>
        <button mat-flat-button color="primary"
                *ngIf="usersList.capabilities.hasCapability('user:create')"
                (click)="usersList.onCreateUser()">
            <mat-icon>person_add</mat-icon>
            Create User
        </button>
        <div class="report-group" *ngIf="usersList.capabilities.hasCapability('user:report')">
            <span class="report-group-label">Reports</span>
            <div class="report-group-icons">
                <button class="report-icon-btn" matTooltip="Download Excel (.xlsx)" (click)="usersList.downloadXLSReport()">
                    <mat-icon>table_chart</mat-icon><span class="report-icon-label">Excel</span>
                </button>
                <button class="report-icon-btn" matTooltip="Download PDF (.pdf)" (click)="usersList.downloadPDFReport()">
                    <mat-icon>article</mat-icon><span class="report-icon-label">PDF</span>
                </button>
                <button class="report-icon-btn" matTooltip="Download CSV (.csv)" (click)="usersList.downloadCSVReport()">
                    <mat-icon>description</mat-icon><span class="report-icon-label">CSV</span>
                </button>
            </div>
        </div>
        <button mat-icon-button (click)="usersList.refreshData()" matTooltip="Refresh" aria-label="Refresh">
            <mat-icon>refresh</mat-icon>
        </button>
    </ng-container>
</lib-page-header>

<lib-users-list #usersList
                [defaultPageSize]="defaultPageSize"
                (dataSetSizeChange)="dataSetSize = $event"></lib-users-list>
